import { Toast } from 'mint-ui'
const userAgent = navigator.userAgent

export default {
    // Toast
    toast(message, time) {
        // 默认提示时间1s
        let arr1 = document.querySelectorAll('.mint-toast')
        let showMessage = true
        if (arr1.length > 0) {
            for (let i = 0, length = arr1.length; i < length; i++) {
                if (arr1[i].innerText === message) {
                    showMessage = false
                } else {
                    arr1[i].parentElement.removeChild(arr1[i])
                }
            }
        }
        if (showMessage && message) {
            Toast({
                message: message,
                duration: time || 1000
            })
        }
    },
    // 获取sessionStorage
    getSession(key) {
        return JSON.parse(window.localStorage.getItem(key))
    },
    // 设置sessionStorage
    setSession(key, data) {
        return window.localStorage.setItem(key, JSON.stringify(data))
    },
    // 获取用户浏览器状态
    getSource() {
        let source = ''
        if (userAgent.match(/Alipay/i)) {
            source = '1'
        } else if (userAgent.match(/MicroMessenger/i)) {
            source = '0'
        } else {
            //source = '2'
            source = '1'
        }
        return source
    },
    // 获取用户环境
    getClient() {
        let client = ''
        if (userAgent.indexOf('android') > -1 || userAgent.indexOf('adr') > -1) {
            client = 'android'
        } else if (userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
            client = 'ios'
        } else {
            client = 'others'
        }
        return client
    },
    // 从url中获取参数
    getRequest() {
        let url = window.location.href
        let theRequest = {}
        if (url.indexOf('?') !== -1) {
            let str = url.split('?')[1]
            let strs = str.split('&')
            for (let i = 0; i < strs.length; i++) {
                theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
            }
        }
        return theRequest
    },
    getBaseUrl() {
        let baseUrl = location.href.split('#')[0]
        if (baseUrl.indexOf('pro.win-credit.com') === -1) {
            return 'https://dev.win-credit.com/'
        } else {
            //return 'https://pro.win-credit.com/'
            return baseUrl
        }
    }
}


// WEBPACK FOOTER //
// ./src/util/common.js